import React, {useState, useRef, useCallback, useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {formatErrors} from "../../../constants";
import {clientNoticeAction, clientNoticeRemoveAction} from "../../../actions/clientAction";
import {toast} from "react-toastify";
import {i_delete, i_edit} from "../../../icons";

export function ClientNote() {
  const clientID = useSelector(state => state.chat.clientID);
  const notices = useSelector(state => state.chat.notices);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const inputRef = useRef();
  const [noticeId, setNoticeId] = useState("");

  const handleSave = useCallback((e) => {
    if (loading) {
      return;
    }
    const message = e.target.value.trim();
    if (!message) {
      return;
    }
    setLoading(true);
    dispatch(clientNoticeAction(noticeId, clientID, message)).then(() => {
      setLoading(false);
      inputRef.current.value = '';
      setNoticeId('');
    }).catch(err => {
      setLoading(false);
      toast.error(formatErrors([err.message]), {position: toast.POSITION.BOTTOM_RIGHT});
    });
  }, [loading, clientID, dispatch, noticeId]);

  const handleDelete = (id) => {
    if (loading) {
      return;
    }
    setLoading(true);
    dispatch(clientNoticeRemoveAction(id)).then(() => {
      setLoading(false);
    }).catch(err => {
      setLoading(false);
      toast.error(formatErrors([err.message]), {position: toast.POSITION.BOTTOM_RIGHT});
    });
  };

  const handleEdit = (id, msg) => {
    inputRef.current.value = msg;
    setNoticeId(id);
  };

  const onKeyDown = useCallback((e) => {
    if (e.keyCode === 13) {
      e.preventDefault();
      handleSave(e);
    }
  }, [handleSave]);

  useEffect(() => {
    const input = inputRef.current;
    if (!input) {
      return;
    }
    input.addEventListener('keydown', onKeyDown);

    return () => input.removeEventListener('keydown', onKeyDown);
  }, [onKeyDown, inputRef]);

  return <div className="user-info__wrapper">
    <input ref={inputRef} type="text" className="user-info__input input" placeholder="Написать заметку" disabled={loading} />
    {notices && notices.map((i) => {
      return <div key={i.id} className="user-info__notes">
        <span className="pointer btn-delete" onClick={() => handleDelete(i.id)}>{i_delete()}</span>
        <span className="pointer btn-edit" onClick={() => handleEdit(i.id, i.message)}>{i_edit()}</span>
        <p className="user-info__note">{i.message}</p>
      </div>;
    })}
  </div>;
}
